module.exports = "<div style=\"overflow:hidden;\" class=\"container-ar\">\r\n    <div id=\"ar\">\r\n        <img class=\"imgSfondo\" src=\"/assets/fourth-page/sfondo_pag_04.png\">\r\n        <img class=\"effAtm\" src=\"/assets/fourth-page/effetti_atmosferici.png\">\r\n        <img class=\"iphoneTr\" [@iphoneState]='stateIphone' src=\"/assets/fourth-page/iphone_bladerunner.gif\">\r\n        <img id=\"cartellone\" class=\"cartellone\" src=\"/assets/fourth-page/cartellone.png\">\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fourth-page/fourth-page.component.html
// module id = ./src/app/fourth-page/fourth-page.component.html
// module chunks = main